import { render, staticRenderFns } from "./ComparisonMessage.vue?vue&type=template&id=37d075cc&scoped=true"
import script from "./ComparisonMessage.vue?vue&type=script&lang=js"
export * from "./ComparisonMessage.vue?vue&type=script&lang=js"
import style0 from "./ComparisonMessage.vue?vue&type=style&index=0&id=37d075cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d075cc",
  null
  
)

export default component.exports